'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LocationModel = function () {
  function LocationModel(data) {
    _classCallCheck(this, LocationModel);

    this.positions = [];
    this.logentries = [];
    this.organisation = null;

    this.values = {
      id: null,
      organisation_id: null,
      business: null,
      postaddress: null,
      postzipcode: null,
      postcity: null,
      postregion: null,
      postcountry: null,
      phone: null,
      email: null,
      fax: null,
      website: null,
      visitaddress: null,
      visitzipcode: null,
      visitcity: null,
      visitregion: null,
      visitcountry: null
    };

    window.PRIM.modelMapper.mapToModel(data, this.values);
  }

  _createClass(LocationModel, [{
    key: 'getTitle',
    value: function getTitle() {
      return [this.values.business].join(' ');
    }
  }, {
    key: 'getSubtitle',
    value: function getSubtitle() {
      var subtitle = [];

      if (this.values.visitcity) {
        subtitle.push(this.values.visitcity);
      }

      if (this.organisation) {
        subtitle.push(this.organisation.values.name);
      }

      return subtitle.join(' ');
    }
  }, {
    key: 'getImage',
    value: function getImage() {
      if (this.organisation) {
        return this.organisation.getImage();
      } else {
        return null;
      }
    }
  }, {
    key: 'getIndex',
    value: function getIndex() {
      if (this.getCompareString()) {
        return this.getCompareString().substring(0, 1).toUpperCase();
      }

      return null;
    }
  }, {
    key: 'getCompareString',
    value: function getCompareString() {
      var title = [];

      if (this.values.business) {
        title.push(this.values.business);
      }

      if (this.values.visitcity) {
        title.push(this.values.visitcity);
      }

      if (this.organisation) {
        title.push(this.organisation.values.name);
      }

      return title.join(' ');
    }
  }, {
    key: 'getJSON',
    value: function getJSON() {
      var result = {};

      window.PRIM.modelMapper.mapToObject(this.values, result);

      return result;
    }
  }]);

  return LocationModel;
}();

exports.default = LocationModel;


//////////////////
// WEBPACK FOOTER
// ./js/modules/location/model/LocationModel.js
// module id = 12
// module chunks = 0